import { IContentClassification, IDifficultyInfo, IItemType, IYearsInfo } from '../../shared';
import { ICheckBox } from '../NQTCheckBox/NQTCheckBox.models';

/**
 * If all ContentClassification items are selected or all are NOT selected, return true
 * Since UI should render ALL in both cases
 * @param cc
 * @returns boolean
 */
export const isAllCC = (cc?: IContentClassification[]|null): boolean => {
  if (!cc) return false;

  let isMixed = false;

  const filteredCC = cc.filter( item => item.isSelected);

  // check top level nodes, if they are checked, all children must be checked
  if ((cc.length !== filteredCC.length)) {
    if (filteredCC.length !== 0) {
      return isMixed;
    }
  } else {
    return !isMixed;
  }

  // Look for any unchecked top nodes and explore children
  cc.forEach( item => {
    if (!item.isSelected) {
      item.childList.forEach( child => {
        if (child.isSelected) {
          isMixed = true;
        }
      });
    }
  });

  // return inverse
  return !isMixed;
};

/**
 * If all items are selected or all items are NOT selected, return true
 * Since UI should render All in both cases
 * @param it
 * @returns boolean
 */
export const isAllChecked = (it?: ICheckBox[]): boolean => {
  if (!it) return true;

  const filtered = it.filter((item) => item.isSelected);

  if (filtered.length !== it.length) {
    if (filtered.length === 0) {
      return true;
    }
  } else {
    return true;
  }

  return false;
};

export const reduceCC = (acc: string[] | string, curr: IContentClassification, ind: number, arr: IContentClassification[]): string[] | string =>{
  curr.childList.forEach(child => {
    if (child.isSelected && typeof acc !== 'string') {
      acc.push(child.contentCategoryName);
    }
  });
  if (ind + 1 !== arr.length) return acc;
  else {
    if (typeof acc !== 'string') {
      return acc.join(', ');
    } else
      return 'Error';
  }

};

export const reduceYr = (acc: string | number[], curr: IYearsInfo, ind: number, arr: IYearsInfo[]): string | number[] => {
  if (curr.isSelected && typeof acc !== 'string') {
    acc.push(curr.year);
  }
  if (ind + 1 !== arr.length) return acc;
  else {
    if (typeof acc !== 'string') {
      return acc.join(', ');
    } else
      return 'Error';
  }
};

export const reduceIT = (acc: string | string[], curr: IItemType, ind: number, arr: IItemType[]): string | string[] => {
  if (curr.isSelected && typeof acc !== 'string') {
    acc.push(curr.itemType);
  }
  if (ind + 1 !== arr.length) return acc;
  else {
    if (typeof acc !== 'string') {
      return acc.join(', ');
    } else
      return 'Error';
  }
};

export const reduceDL = (acc: string | string[], curr: IDifficultyInfo, ind: number, arr: IDifficultyInfo[]): string | string[] => {
  if (curr.isSelected && typeof acc !== 'string') {
    acc.push(curr.difficultyType);
  }
  if (ind + 1 !== arr.length) return acc;
  else {
    if (typeof acc !== 'string') {
      return acc.join(', ');
    } else
      return 'Error';
  }
};

